import { BRAND, type Account, type ResetInfo, t } from '@procumi/shared';
import { useState } from 'react';
import { ErrorBox, Loading } from '../components/StateBox';
import { useAsync } from '../hooks/useAsync';
import { api, errMsg } from '../lib/api';
import { rich } from '../lib/rich';

/**
 * Ecranul din linkul de parolă nouă. Ca la invitație: emailul e cel al
 * linkului, omul alege doar parola, apoi intră direct.
 */
export function ResetScreen({
  token,
  onDone,
  onGiveUp,
}: {
  token: string;
  onDone: (account: Account) => void;
  /** Link expirat sau „Înapoi": ecranul obișnuit de intrare. */
  onGiveUp: () => void;
}) {
  const { data, error, loading } = useAsync<ResetInfo>(() => api.resetInfo(token), [token]);
  const [password, setPassword] = useState('');
  const [problema, setProblema] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setProblema(null);
    try {
      onDone(await api.resetPassword({ token, password }));
    } catch (err) {
      setProblema(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">
          <img className="logo" src="/brand/procumi-lockup.svg" alt={BRAND.name} />
          <small>{BRAND.tagline}</small>
        </div>

        <div className="sheet pad" style={{ display: 'grid', gap: 14 }}>
          {loading ? <Loading /> : null}

          {!loading && error ? (
            <>
              <ErrorBox error={error} />
              <button className="btn" type="button" onClick={onGiveUp}>
                {t('Mergi la ecranul de intrare')}
              </button>
            </>
          ) : null}

          {!loading && data ? (
            <>
              <div>
                <h2>{t('Parolă nouă')}</h2>
                <p className="hint" style={{ marginTop: 6 }}>
                  {rich(
                    'Pentru contul <b>{0}</b>. După ce o salvezi, intri direct, iar pe celelalte calculatoare și telefoane va trebui să intri din nou.',
                    data.email,
                  )}
                </p>
              </div>

              <label className="f" htmlFor="reset-password">
                {t('Parola nouă')}
                <input
                  id="reset-password"
                  className="inp"
                  type="password"
                  value={password}
                  autoComplete="new-password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span className="hint" style={{ margin: 0 }}>
                  {t('Cel puțin 8 caractere.')}
                </span>
              </label>

              {problema ? (
                <div className="auth-err" role="alert">
                  {problema}
                </div>
              ) : null}

              <button className="btn primary" type="submit" disabled={busy}>
                {busy ? t('Se salvează…') : t('Salvează parola și intră')}
              </button>
              <button className="btn" type="button" onClick={onGiveUp}>
                {t('Înapoi')}
              </button>
            </>
          ) : null}
        </div>
      </form>
    </div>
  );
}
